import axios from "../axios-private";

export function editUser(request) {
  return axios.post("/user/edit", request);
}

export function deleteUser(username) {
  return axios.post("/user/delete", { username: username });
}

export function createUser(requestMessage) {
  return axios.post("/user/add", requestMessage);
}

export function changePassUser(request) {
  return axios.post("user/changepass", request);
}

export function getOperatorPhone(request) {
  return axios.post("user/getoperatorphone", request);
}

export function setOperatorPhone(request) {
  return axios.post("user/setoperatorphone", request);
}
